import React, { useState } from "react";
import { useStore } from "../../context";
import { navigate } from "@reach/router";
import { urlAuth } from "../../utils";
import Swal from "sweetalert2";
import logoanai from "../../images/logos/logoanai.png";

const AuthPension = () => {
  const { dispatch } = useStore();
  const [user, setUser] = useState("");
  const [passw, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  function Login(event) {
    event.preventDefault();
    setLoading(true);
    const data = {
      username: "A" + user,
      password: passw,
    };
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    fetch(`${urlAuth}auth/login`, options)
      .then((res) => res.json())
      .then((data) => {
        if (data.token) {
          dispatch({ type: "SET_TOKEN", payload: data });
          navigate("/pension/list");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error de autenticación",
            text: "Credenciales incorrectas. Verifique su usuario y contraseña.",
            confirmButtonColor: "#0d1b3e",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error de promesa:", err);
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo conectar al servidor. Intente de nuevo.",
          confirmButtonColor: "#0d1b3e",
        });
      });
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">💳 Pago de Pensiones</div>
        <div className="login-subtitle">
          Ingrese sus credenciales para acceder al sistema de pagos
          <br />
          <span style={{ color: 'var(--anai-secondary-dark)', fontWeight: 600, fontSize: '0.82rem' }}>
            ⚓ Academia Naval Almirante Illingworth
          </span>
        </div>

        <form noValidate onSubmit={Login}>
          <div className="modern-input-group">
            <label htmlFor="username">👤 Usuario (Cédula o RUC)</label>
            <input
              type="text"
              id="username"
              placeholder="Ingrese su cédula o RUC"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoFocus
              required
            />
          </div>

          <div className="modern-input-group">
            <label htmlFor="password">🔒 Contraseña</label>
            <input
              type="password"
              id="password"
              placeholder="Ingrese su contraseña"
              value={passw}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn-modern btn-primary"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span className="spinner-ring" style={{ width: 22, height: 22, borderWidth: 3 }}></span>
                Ingresando...
              </span>
            ) : (
              "🚀 INGRESAR"
            )}
          </button>
        </form>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.72rem', color: '#aaa', marginTop: 6, display: 'inline-block', letterSpacing: '0.03em' }}>
            Diseñado y Desarrollado por Departamento de Sistemas ANAI
          </span>
        </div>
      </div>
    </div>
  );
};

export default AuthPension;
